import type { FunctionComponent } from 'react';

import { useCardId } from '@trello/id-context';
import { CardFrontTestIds } from '@trello/test-ids';

import { CARD_ID_ATTRIBUTE } from './CardFront.constants';
import { CardFrontName } from './CardFrontName';

import styles from './MinimalCard.less';

interface MinimalCardProps {
  name?: string;
  url?: string;
}

/**
 * Embedded representation of the MinimalCard component. Designed to be used for
 * internal use within the CardFront component, where containing styles and data
 * are already available.
 */
export const MinimalCard: FunctionComponent<MinimalCardProps> = ({
  name,
  url,
}) => {
  const cardId = useCardId();

  return (
    <div
      className={styles.details}
      data-testid={CardFrontTestIds.MinimalCard}
      {...{ [CARD_ID_ATTRIBUTE]: cardId }}
    >
      <CardFrontName name={name} url={url} />
    </div>
  );
};
